import { Component, EventEmitter, Inject, Output, ChangeDetectionStrategy } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog'
import { MatButton } from '@angular/material/button'
import { MatCheckbox } from '@angular/material/checkbox'
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core'
import { MatButtonToggle, MatButtonToggleGroup } from '@angular/material/button-toggle'
import { SpinnerComponent } from '../spinner/spinner.component'

export type ExportDialogInputData = {
  allowTranscriptDownload: boolean
  allowMinutesDownload: boolean
  allowOutlineDownload: boolean
  hasMinutes: boolean
  hasOutline: boolean
  hasTranscript: boolean
  hasActionItems: boolean
}

export type ExportDialogOutputData = {
  includeMinutes: boolean
  minutesFormat: 'docx' | 'pdf'
  includeOutline: boolean
  outlineFormat: 'docx' | 'pdf'
  includeTranscript: boolean
  transcriptFormat: 'docx' | 'pdf'
  includeActionItems: boolean
  actionItemsFormat: 'csv'
}

@Component({
  selector: 'app-export-dialog',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MatButton,
    MatCheckbox,
    TranslatePipe,
    TranslateDirective,
    MatButtonToggleGroup,
    MatButtonToggle,
    MatDialogTitle,
    SpinnerComponent,
  ],
  templateUrl: './export-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './export-dialog.component.scss',
})
export class ExportDialogComponent {
  @Output() exportClicked = new EventEmitter<ExportDialogOutputData>()

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ExportDialogInputData,
    public dialogRef: MatDialogRef<ExportDialogComponent>
  ) {}

  loading = false

  exportData: ExportDialogOutputData = {
    includeMinutes: false,
    minutesFormat: 'docx',
    includeOutline: false,
    outlineFormat: 'docx',
    includeTranscript: this.data.hasTranscript && this.data.allowTranscriptDownload,
    transcriptFormat: 'docx',
    includeActionItems: false,
    actionItemsFormat: 'csv',
  }

  onExport(): void {
    this.loading = true
    this.exportClicked.emit(this.exportData)
  }

  get isExportDisabled(): boolean {
    return !this.exportData.includeTranscript && !this.exportData.includeMinutes && !this.exportData.includeActionItems && !this.exportData.includeOutline
  }
}
